/**
 * Renders the session panel beside the sidebar when open on Home.
 */
import * as React from "react";
import { useLocation } from "react-router-dom";
import { useSessionPanel } from "@/contexts/SessionPanelContext";
import { SessionHistoryRail } from "@/components/chat/SessionHistoryRail";
import { isHomePath } from "@/lib/routes";

export function SessionPanelSlot({ sidebarCollapsed }: { sidebarCollapsed: boolean }) {
  const location = useLocation();
  const {
    open,
    setOpen,
    recent,
    older,
    loading,
    activeSessionId,
    handlers,
    renameSession,
    deleteSession,
  } = useSessionPanel();

  const [isMobile, setIsMobile] = React.useState(() =>
    typeof window !== "undefined"
      ? window.matchMedia("(max-width: 767px)").matches
      : false,
  );

  React.useEffect(() => {
    const mq = window.matchMedia("(max-width: 767px)");
    const onChange = (): void => setIsMobile(mq.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  const expanded = open && isHomePath(location.pathname);

  return (
    <SessionHistoryRail
      recent={recent}
      older={older}
      activeSessionId={activeSessionId}
      loading={loading}
      sidebarCollapsed={sidebarCollapsed}
      expanded={expanded}
      isMobile={isMobile}
      mobileOpen={expanded}
      onMobileClose={() => setOpen(false)}
      onClose={() => setOpen(false)}
      onSelect={handlers.onSelect}
      onNewChat={handlers.onNewChat}
      onRename={async (id, title) => {
        await renameSession(id, title);
      }}
      onDelete={async (id) => {
        const wasActive = id === activeSessionId;
        await deleteSession(id);
        if (wasActive) handlers.onNewChat();
      }}
    />
  );
}
